export default "__VITE_ASSET__CAhICiT3__"